export const formatDate = (dateString) => {
	return new Date(dateString).toLocaleString('ru', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		timezone: 'UTC',
		hour: 'numeric',
		minute: 'numeric',
	});
};

export const formatDate2 = (dateString) => {
	return new Date(dateString).toLocaleString('ru', {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
	});
};

export const scroll = (selector) => {
	const section = document.querySelector(`${selector}`);
	return section.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const checkWindow = (maxWidthPixel) =>
	typeof window !== 'undefined' &&
	window.matchMedia(`(max-width: ${maxWidthPixel}px)`).matches;

export const isMobile = checkWindow(1024);

export const isPhone = checkWindow(768);

export const rebuildData = (values) => {
	let formData = new FormData();
	Object.keys(values).forEach((key) => {
		if (key === 'region_id') {
			return formData.append(key, values[key].value);
		}
		formData.append(key, values[key]);
	});
	values.videos?.map((link, index) => {
		return formData.append(`videos[${index}]`, link);
	});
	values.images?.map((image, index) => {
		return formData.append(`images[${index}]`, image);
	});

	formData.delete('videos');
	formData.delete('video');
	formData.delete('images');
	return formData;
};

